import React from 'react';
import { Form as AntdForm } from 'antd';

export const Form = ({ ...rest }) => {
    return <AntdForm layout={'vertical'} {...rest} />;
};

export const FormItem = ({ ...rest }) => {
    return <AntdForm.Item {...rest} />;
};
